import { useRef, useState } from "react";
import { Dropdown, DropdownOption, DropdownProps } from "../dropdown";
import useRegionerDropdownOptions, { SelectedRegionIdsResult } from "../hooks/useRegionerDropdownOptions";
import { ForSelectDropdownGenericProps } from "./forSelectDropdown";
import useRestrictedDropdownOptions from "../hooks/useRestrictedDropdownOptions";
import { SelectInstance } from "react-select";

export type RegionerMultiDropdownProps <T, IsMulti extends boolean = false> = {
    onChangeCallback: (newValue: SelectedRegionIdsResult) => void;
} & ForSelectDropdownGenericProps<T>
& Pick<DropdownProps<T, DropdownOption<T>, false, IsMulti>, "isMulti">;

const RegionerMultiDropdown = ({ 
    initialSelectedOption, 
    onChangeCallback, 
    title="", 
    placeholder="", 
    permissions, 
    restrictedValues, 
    disable=false, 
    onMenuCloseCallback
} : RegionerMultiDropdownProps<string, true>) => {

    const ref = useRef<SelectInstance<DropdownOption<string>, true>>(null);

    const { regionerDropdownOptions, transformSelectedOptionsToRegionIds } = useRegionerDropdownOptions(permissions);
    const { restrictedDropdownOptions, isLoading: restrictedDropdownIsLoading } = useRestrictedDropdownOptions(regionerDropdownOptions, restrictedValues, true);

    const [selectedOptions, setSelectedOptions] = useState<string[]>(transformSelectedOptionsToRegionIds(initialSelectedOption as string[])?.regionIds ?? []);

    const isDisabled = disable || (!restrictedDropdownIsLoading && restrictedDropdownOptions.length === 0);

    return (
        <div className="margin-top-s">
            {title &&
                <label>{title}</label>
            }

            <Dropdown
                ref={ref}
                placeholder={placeholder}
                options={restrictedDropdownOptions}
                onChange={newMultiValue => {     
                    const selectedRegionIdsResult = transformSelectedOptionsToRegionIds(newMultiValue.map(x => x.value));
                    setSelectedOptions(selectedRegionIdsResult.regionIds ?? []);
                    onChangeCallback(selectedRegionIdsResult);
                }}
                value={restrictedDropdownOptions.filter(x => selectedOptions.includes(x.value))}
                isClearable
                isDisabled={isDisabled}
                isMulti
                onMenuClose={onMenuCloseCallback}
            />

        </div>
    );
}

export default RegionerMultiDropdown;